/* ------------------- IMPORTS */
import styled from '@emotion/styled'
import Utils from 'api/Utils'
import { Box } from 'components'
import { useEffect, useState } from 'react'
import { IPostVariant, YTCategory } from 'types/PostInterface'
import { ExtraTitle } from '../GenericExtras/ExtraTitle'
import { T } from 'utils'
import { updatePost } from 'utils/PostUtils/Post'
import ExtraSelect from '../GenericExtras/ExtraSelect/ExtraSelect'

/* ------------------- INTERFACES  */

interface Props {
  post: IPostVariant
}

export const YoutubeCategory = ({ post }: Props) => {
  /* ----------------- STATE  */
  const [categories, setCategories] = useState<YTCategory[]>([])
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)
  const [selectedCategory, setSelectedCategory] = useState<YTCategory | null>(post.data.category || null)

  /* ----------------- VARIABLES  */
  const { variantId } = post

  /* ----------------- METHODS  */
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev)
  }

  const handleSelectedCategory = (category: YTCategory) => {
    updatePost(variantId, {
      category: {
        id: category.id,
        title: category.title,
      },
    })
    setSelectedCategory(category)
  }

  /* ----------------- API CALL  */
  const fetchCategories = async () => {
    const request = await Utils.getYouTubeCategories('', post.info.account.account_id as string)
    const data = request.data as YTCategory[]

    setCategories(data)
    // se le categorie esistono aggiorno il post con la prima categoria selezionata
    if (data) {
      !post.data.category &&
        updatePost(variantId, {
          category: {
            id: data[0].id,
            title: data[0].title,
          },
        })

      // se esiste già una categoria selezionata la setto come categoria selezionata
      if (post.data.category) setSelectedCategory(post.data.category)
      // altrimento setto la prima categoria come categoria selezionata
      else setSelectedCategory(data[0])
    }
  }

  /* ----------------- USEEFFECT  */
  useEffect(() => {
    fetchCategories()
  }, [])

  return (
    <YoutubeCategoryContainer>
      <ExtraTitle text={T.postPage.youtubeTubeExtra.category} />

      <ExtraSelect
        classes="select-category-youtube"
        selectWith="default"
        toggleDropdown={toggleDropdown}
        isDropdownOpen={isDropdownOpen}
        items={categories}
        dropdownHeaderText={selectedCategory ? selectedCategory.title : T.postPage.youtubeTubeExtra.selectCategory}
        onSelect={handleSelectedCategory}
        selectedItems={selectedCategory}
        truncateTextNum={30}
      />
    </YoutubeCategoryContainer>
  )
}

const YoutubeCategoryContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`
